import { GroupedDatasetVersionSchemaWithOptionalAsOf } from '@/Pages/Dataset/types';
import { DATASET_VERSION_FORMATTER } from '@/utils/version-format';

export function getVersionName(
  version: GroupedDatasetVersionSchemaWithOptionalAsOf
) {
  const tags = version.tags ?? [];
  return tags.length
    ? tags.join(', ')
    : version.as_of
    ? `${DATASET_VERSION_FORMATTER.format(new Date(version.as_of))}`
    : '';
}
